module.exports = __webpack_public_path__ + "static/media/06.260fca16.png";